import { UxGameController } from './ux-game-controller';
import { Observable } from 'rxjs';
import { UxGameServices } from 'src/app/core/services/ux-game/ux-game-services';
import { GameId } from 'src/app/model/game/game-id';
import { SolitaireUxGameListener } from '../listeners/solitaire-ux-game-listener';
import { SolitaireMainScene } from 'src/games/phasersolitaire/game/scenes/solitaire-main-scene';
import { SolitairePreloadScene } from 'src/games/phasersolitaire/game/scenes/solitaire-preload-scene';
import { ActionBus } from 'game-logic';
import { UxGameServiceAction } from 'src/app/core/services/ux-game/ux-game-service-action';

export class SolitaireUxGameController extends UxGameController {
  public override get gameId(): GameId {
    return GameId.Solitaire;
  }
  public get noMoreHints$(): Observable<void> {
    return this.solitaireListener.noMoreHints$;
  }

  private solitaireListener: SolitaireUxGameListener;
  private solitaireMainScene: SolitaireMainScene;

  constructor(
    gameListener: SolitaireUxGameListener,
    gameServiceActionBus: ActionBus<UxGameServiceAction>,
    services: UxGameServices,
  ) {
    const preloadScene = new SolitairePreloadScene(services.themeService.solitaireAssetPath());
    preloadScene.setGameListener(gameListener);

    const mainScene = new SolitaireMainScene();

    super(gameListener, preloadScene, mainScene, gameServiceActionBus, services);

    this.solitaireListener = gameListener;
    this.solitaireMainScene = mainScene;
  }

  undoButtonClick(): void {
    this.solitaireMainScene.undo();
  }

  hintButtonClick(): void {
    this.solitaireMainScene.hint();
  }

  protected override resetGame(): void {
    this.solitaireMainScene.resetGameScene();
  }

  public override setGameVisible(isVisible: boolean): void {
    this.solitaireMainScene.setGameVisible(isVisible);
  }
}
